(function () {
  function initDAMicroNav() {
    const nav = document.querySelector('[data-da-micro-nav]');

    if (!nav || nav.dataset.initialized === 'true') return;

    nav.dataset.initialized = 'true';

    const panels = Array.from(
      nav.querySelectorAll('[data-da-panel]')
    );

    if (!panels.length) return;

    const searchInput = nav.querySelector('[data-da-nav-search]');
    const searchClear = nav.querySelector('[data-da-nav-search-clear]');

    const searchIndexElement = nav.querySelector(
      '[data-da-nav-search-index]'
    );

    const searchResults = nav.querySelector(
      '[data-da-nav-search-results]'
    );

    const searchList = nav.querySelector(
      '[data-da-nav-search-list]'
    );

    const searchEmpty = nav.querySelector(
      '[data-da-nav-search-empty]'
    );


    /* ============================================
       Search Index
       ============================================ */

    let searchIndex = [];

    if (searchIndexElement) {
      try {
        searchIndex = JSON.parse(searchIndexElement.textContent);
      } catch (error) {
        console.warn(
          'DA Micro Navigator: search index could not be parsed.',
          error
        );
      }
    }


    const searchSynonyms = {

  /* ============================================
     Uniforms
     ============================================ */

  gi: [
    'uniform',
    'karate uniform',
    'martial arts uniform'
  ],

  gis: [
    'uniform',
    'karate uniform',
    'martial arts uniform'
  ],

  karategi: [
    'karate uniform',
    'uniform',
    'gi'
  ],

  judogi: [
    'judo uniform',
    'uniform',
    'gi'
  ],

  kimono: [
    'uniform',
    'karate uniform',
    'gi'
  ],

  dobok: [
    'uniform',
    'taekwondo uniform',
    'martial arts uniform'
  ],

  uniform: [
    'gi',
    'karate uniform',
    'martial arts uniform'
  ],


  /* ============================================
     Martial Arts Disciplines
     ============================================ */

  mma: [
    'mixed martial arts',
    'combat sports',
    'boxing',
    'kickboxing',
    'grappling'
  ],

  'mixed martial arts': [
    'mma',
    'combat sports',
    'boxing',
    'kickboxing',
    'grappling'
  ],

  boxing: [
    'combat sports',
    'mma',
    'boxing gloves',
    'training gloves'
  ],

  kickboxing: [
    'combat sports',
    'mma',
    'boxing',
    'muay thai',
    'kick boxing'
  ],

  'muay thai': [
    'kickboxing',
    'combat sports',
    'mma',
    'boxing'
  ],

  karate: [
    'traditional martial arts',
    'traditional',
    'gi',
    'uniform',
    'sparring'
  ],

  judo: [
    'traditional martial arts',
    'traditional',
    'gi',
    'uniform',
    'grappling'
  ],

  taekwondo: [
    'traditional martial arts',
    'traditional',
    'tkd',
    'uniform',
    'sparring'
  ],

  tkd: [
    'taekwondo',
    'traditional martial arts',
    'uniform',
    'sparring'
  ],

  'traditional martial arts': [
    'karate',
    'judo',
    'taekwondo',
    'traditional'
  ],

  traditional: [
    'traditional martial arts',
    'karate',
    'judo',
    'taekwondo'
  ],

  grappling: [
    'mma',
    'judo',
    'jiu jitsu',
    'bjj',
    'groundwork'
  ],

  groundwork: [
    'grappling',
    'judo',
    'jiu jitsu',
    'bjj'
  ],

  bjj: [
    'jiu jitsu',
    'jiu-jitsu',
    'grappling',
    'mma'
  ],

  'jiu jitsu': [
    'bjj',
    'grappling',
    'mma'
  ],

  'jiu-jitsu': [
    'bjj',
    'grappling',
    'mma'
  ],


  /* ============================================
     Protective / Sparring Equipment
     ============================================ */

  'sparring gear': [
    'protective',
    'protective gear',
    'sparring equipment'
  ],

  'sparring equipment': [
    'sparring gear',
    'protective gear',
    'protective'
  ],

  sparring: [
    'protective',
    'protective gear',
    'sparring gear'
  ],

  protection: [
    'protective',
    'protective gear',
    'sparring gear'
  ],

  protective: [
    'protective gear',
    'sparring gear',
    'protection'
  ],

  pads: [
    'protective gear',
    'sparring gear',
    'guards'
  ],

  guard: [
    'protective',
    'protective gear'
  ],

  guards: [
    'protective',
    'protective gear'
  ],

 boots: [
  'boot',
  'kicks',
  'foot guard',
  'foot guards',
  'foot protection',
  'sparring gear'
],

boot: [
  'boots',
  'kicks',
  'foot guard',
  'foot protection',
  'sparring gear'
],

kick: [
  'kicks',
  'boots',
  'foot guard',
  'foot protection',
  'sparring gear'
],

kicks: [
  'kick',
  'boots',
  'foot guards',
  'foot protection',
  'sparring gear'
],

'foot guard': [
  'foot guards',
  'kicks',
  'boots',
  'foot protection'
],

'foot guards': [
  'foot guard',
  'kicks',
  'boots',
  'foot protection'
],

'foot protection': [
  'foot guard',
  'foot guards',
  'kicks',
  'boots'
],

shoes: [
  'footwear',
  'training shoes',
  'martial arts shoes'
],

footwear: [
  'shoes',
  'training shoes',
  'martial arts shoes'
],

  /* ============================================
     Head Protection
     ============================================ */

  'head guard': [
    'headgear',
    'head protection',
    'sparring gear'
  ],

  headguard: [
    'headgear',
    'head protection',
    'sparring gear'
  ],

  helmet: [
    'headgear',
    'head protection'
  ],

  headgear: [
    'head guard',
    'head protection',
    'helmet'
  ],

  'head protection': [
    'headgear',
    'head guard'
  ],


  /* ============================================
     Leg / Shin Protection
     ============================================ */

  'shin pad': [
    'shin guard',
    'shin protection'
  ],

  'shin pads': [
    'shin guards',
    'shin protection'
  ],

  'shin guard': [
    'shin pad',
    'shin protection'
  ],

  'shin guards': [
    'shin pads',
    'shin protection'
  ],

  'leg guard': [
    'shin guard',
    'shin protection'
  ],

  'leg guards': [
    'shin guards',
    'shin protection'
  ],

  'shin protection': [
    'shin guards',
    'shin pads'
  ],


  /* ============================================
     Hand Protection / Gloves
     ============================================ */

  gloves: [
    'boxing gloves',
    'training gloves',
    'sparring gloves',
    'hand protection'
  ],

  'boxing gloves': [
    'gloves',
    'training gloves',
    'combat sports',
    'boxing'
  ],

  'sparring gloves': [
    'gloves',
    'hand protection',
    'sparring gear'
  ],

  'training gloves': [
    'gloves',
    'boxing gloves',
    'combat sports'
  ],

  'hand protection': [
    'gloves',
    'sparring gloves'
  ],


  /* ============================================
     Belts / Rank
     ============================================ */

  belt: [
    'rank belt',
    'martial arts belt',
    'karate belt'
  ],

  belts: [
    'rank belts',
    'martial arts belts',
    'karate belts'
  ],

  'rank belt': [
    'belt',
    'martial arts belt',
    'karate belt'
  ],

  'black belt': [
    'rank belt',
    'belt',
    'martial arts belt'
  ],

  obi: [
    'belt',
    'rank belt',
    'martial arts belt'
  ],

  rank: [
    'belt',
    'rank belt',
    'uniform'
  ],


  /* ============================================
     Training Equipment
     ============================================ */

  mitt: [
    'focus mitt',
    'focus mitts',
    'training target'
  ],

  mitts: [
    'focus mitts',
    'focus mitt',
    'training targets'
  ],

  'focus mitt': [
    'mitt',
    'training target',
    'boxing'
  ],

  'focus mitts': [
    'mitts',
    'training targets',
    'boxing'
  ],

  pad: [
    'training pad',
    'target',
    'shield'
  ],

  target: [
    'training target',
    'focus mitt',
    'pad'
  ],

  targets: [
    'training targets',
    'focus mitts',
    'pads'
  ],

  shield: [
    'kick shield',
    'training shield',
    'target'
  ],

  'kick shield': [
    'shield',
    'training target',
    'kickboxing'
  ],

  'thai pads': [
    'training pads',
    'kickboxing',
    'muay thai',
    'targets'
  ],


  /* ============================================
     Bags
     ============================================ */

  duffel: [
    'bag',
    'gear bag',
    'equipment bag'
  ],

  duffle: [
    'bag',
    'gear bag',
    'equipment bag'
  ],

  backpack: [
    'bag',
    'gear bag'
  ],

  'gear bag': [
    'bag',
    'duffel',
    'equipment bag'
  ],

  'equipment bag': [
    'bag',
    'gear bag',
    'duffel'
  ],


  /* ============================================
     Patches / Branding
     ============================================ */

  patch: [
    'patches',
    'uniform patch',
    'embroidered patch'
  ],

  patches: [
    'patch',
    'uniform patches',
    'embroidered patches'
  ],

  emblem: [
    'patch',
    'logo patch'
  ],

  crest: [
    'patch',
    'emblem'
  ],

  logo: [
    'branding',
    'patch',
    'customization'
  ],

  branding: [
    'logo',
    'customization',
    'patch'
  ],


  /* ============================================
     Customization
     ============================================ */

  custom: [
    'customization',
    'customized',
    'personalized'
  ],

  customization: [
    'custom',
    'branding',
    'embroidery',
    'printing'
  ],

  embroidery: [
    'customization',
    'branding',
    'embroidered'
  ],

  printing: [
    'customization',
    'branding',
    'print'
  ],


  /* ============================================
     Audience / Use
     ============================================ */

  dojo: [
    'school',
    'martial arts school',
    'academy'
  ],

  dojang: [
    'school',
    'martial arts school',
    'academy'
  ],

  academy: [
    'school',
    'martial arts school'
  ],

  instructor: [
    'teacher',
    'coach',
    'educator'
  ],

  coach: [
    'instructor',
    'trainer'
  ],

  student: [
    'martial arts student',
    'training'
  ],

  youth: [
    'kids',
    'children',
    'junior'
  ],

  kids: [
    'youth',
    'children',
    'junior'
  ],

junior: [
  'youth',
  'kids'
],

kfa: [
  'karate for all'
],

'karate for all': [
  'kfa'
],

ussd: [
  'united',
  'united studios',
  'united studios of self defense'
],

united: [
  'ussd',
  'united studios',
  'united studios of self defense'
],

'united studios': [
  'ussd',
  'united studios of self defense'
],

'united studios of self defense': [
  'ussd',
  'united studios'
]
};


    /* ============================================
       Navigation State
       ============================================ */

    const history = [];

    let activePanel =
      panels.find(panel => panel.classList.contains('is-active')) ||
      panels[0];


    /* ============================================
       Search Helpers
       ============================================ */

    function normalizeSearchValue(value) {
      return String(value || '')
        .toLowerCase()
        .trim();
    }


    function normalizeKeywordList(value) {
      if (Array.isArray(value)) {
        return value
          .map(item => normalizeSearchValue(item))
          .filter(Boolean);
      }

      if (!value) return [];

      return String(value)
        .split(',')
        .map(item => normalizeSearchValue(item))
        .filter(Boolean);
    }


    function escapeHTML(value) {
      const div = document.createElement('div');

      div.textContent = value || '';

      return div.innerHTML;
    }


    function getExpandedSearchTerms(query) {
      const normalizedQuery = normalizeSearchValue(query);

      if (!normalizedQuery) {
        return {
          originalTerms: [],
          expandedTerms: []
        };
      }

      const originalTerms = normalizedQuery
        .split(/\s+/)
        .filter(Boolean);

      const expandedTerms = new Set(originalTerms);


      if (searchSynonyms[normalizedQuery]) {
        searchSynonyms[normalizedQuery].forEach(value => {
          normalizeSearchValue(value)
            .split(/\s+/)
            .filter(Boolean)
            .forEach(term => expandedTerms.add(term));
        });
      }


      originalTerms.forEach(term => {
        if (!searchSynonyms[term]) return;

        searchSynonyms[term].forEach(value => {
          normalizeSearchValue(value)
            .split(/\s+/)
            .filter(Boolean)
            .forEach(expandedTerm => {
              expandedTerms.add(expandedTerm);
            });
        });
      });


      return {
        originalTerms,
        expandedTerms: Array.from(expandedTerms)
      };
    }


    /* ============================================
       Product Search
       ============================================ */

    function searchProducts(query) {
      const normalizedQuery = normalizeSearchValue(query);

      if (!normalizedQuery) return [];

      const {
        originalTerms,
        expandedTerms
      } = getExpandedSearchTerms(normalizedQuery);


      return searchIndex
        .map((product, originalIndex) => {
          const title = normalizeSearchValue(product.title);
          const subtitle = normalizeSearchValue(product.subtitle);
          const hook = normalizeSearchValue(product.hook);
          const vendor = normalizeSearchValue(product.vendor);
          const type = normalizeSearchValue(product.type);
          const handle = normalizeSearchValue(product.handle);

          const keywords = normalizeKeywordList(product.keywords);

          const keywordText = keywords.join(' ');

          const haystack = [
            title,
            subtitle,
            hook,
            vendor,
            type,
            handle,
            keywordText
          ].join(' ');


          const matchesAllTerms = originalTerms.every(originalTerm => {
            if (haystack.includes(originalTerm)) {
              return true;
            }

            const synonyms = searchSynonyms[originalTerm] || [];

            return synonyms.some(synonym =>
              haystack.includes(normalizeSearchValue(synonym))
            );
          });

          if (!matchesAllTerms) return null;


          let score = 0;


          if (title === normalizedQuery) {
            score += 100;
          }

          if (title.startsWith(normalizedQuery)) {
            score += 50;
          }

          if (title.includes(normalizedQuery)) {
            score += 25;
          }


          originalTerms.forEach(term => {
            if (title.includes(term)) {
              score += 12;
            }

            if (keywords.some(keyword => keyword.includes(term))) {
              score += 10;
            }

            if (subtitle.includes(term)) {
              score += 5;
            }

            if (hook.includes(term)) {
              score += 5;
            }

            if (type.includes(term)) {
              score += 3;
            }

            if (handle.includes(term)) {
              score += 2;
            }

            if (vendor.includes(term)) {
              score += 1;
            }
          });


          expandedTerms.forEach(term => {
            if (originalTerms.includes(term)) return;

            if (title.includes(term)) {
              score += 8;
            }

            if (keywords.some(keyword => keyword.includes(term))) {
              score += 7;
            }

            if (subtitle.includes(term)) {
              score += 4;
            }

            if (hook.includes(term)) {
              score += 4;
            }

            if (type.includes(term)) {
              score += 2;
            }
          });


          return {
            product,
            score,
            originalIndex
          };
        })
        .filter(Boolean)
        .sort((a, b) => {
          if (b.score !== a.score) {
            return b.score - a.score;
          }

          return a.originalIndex - b.originalIndex;
        })
        .map(item => item.product);
    }


    /* ============================================
       Render Search Results
       ============================================ */
function renderSearchResults(products) {
  if (!searchList || !searchEmpty) return;

  /*
   * Cancel animations on results that are about
   * to be removed.
   */
  searchList
    .querySelectorAll('.DAMicroNav__SearchResult')
    .forEach(item => {
      cancelRevealAnimation(item);
    });

  searchList.innerHTML = '';

  searchEmpty.hidden = products.length > 0;


  /*
   * Build the new results.
   */
  products.forEach(product => {
    const isLocked = product.accessState === 'locked';

const result = document.createElement(
  isLocked ? 'button' : 'a'
);

if (isLocked) {
  result.type = 'button';

  result.setAttribute(
    'data-da-locked-product',
    ''
  );

  result.setAttribute(
    'data-da-locked-product-title',
    product.title
  );

  result.setAttribute(
    'data-da-locked-product-url',
    product.url
  );

  result.setAttribute(
    'aria-haspopup',
    'dialog'
  );
} else {
  result.href = product.url;
}

result.className =
  'DAMicroNav__SearchResult' +
  (!product.image
    ? ' DAMicroNav__SearchResult--noImage'
    : '') +
  (product.accessState === 'locked'
    ? ' is-locked'
    : '');


if (product.accessState === 'locked') {
  result.setAttribute(
    'data-da-locked-product',
    ''
  );

  result.setAttribute(
    'data-da-locked-product-title',
    product.title
  );

  result.setAttribute(
    'data-da-locked-product-url',
    product.url
  );

  result.setAttribute(
    'aria-haspopup',
    'dialog'
  );
}

   const lockedBadge = isLocked
  ? `
    <span
      class="DAMicroNav__LockIcon"
      aria-label="Exclusive product"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="5" y="10" width="14" height="10" rx="2"></rect>
        <path d="M8 10V7a4 4 0 0 1 8 0v3"></path>
      </svg>
    </span>
  `
  : '';


const image = product.image
  ? `
    <div class="DAMicroNav__SearchResultImage">
      <img
        src="${escapeHTML(product.image)}"
        alt="${escapeHTML(product.title)}"
        loading="lazy"
      >

      ${lockedBadge}
    </div>
  `
  : '';

    const subtitle = product.subtitle
  ? `
    <span class="DAMicroNav__SearchResultSubtitle">
      ${escapeHTML(product.subtitle)}
    </span>
  `
  : '';

    result.innerHTML = `
  <span class="DAMicroNav__SearchResultInner">
    ${image}

    <span class="DAMicroNav__SearchResultContent">

      <span class="DAMicroNav__SearchResultTitle">
        ${escapeHTML(product.title)}
      </span>

      ${subtitle}

    </span>
  </span>
`;

    searchList.appendChild(result);
  });


  /*
   * Animate results using the same reveal settings
   * as normal navigator content.
   */
  const items = Array.from(
    searchList.querySelectorAll('.DAMicroNav__SearchResult')
  );

  if (!items.length) return;

  const {
    duration,
    distance,
    stagger
  } = getRevealSettings();


  items.forEach((item, index) => {
    const animation = item.animate(
      [
        {
          opacity: 0,
          transform: `translateY(${distance}px)`
        },
        {
          opacity: 1,
          transform: 'translateY(0)'
        }
      ],
      {
        duration: duration,
        delay: index * stagger,
        easing: 'cubic-bezier(.22, 1, .36, 1)',
        fill: 'both'
      }
    );

    item._daRevealAnimation = animation;

    animation.finished
      .then(() => {
        if (item._daRevealAnimation !== animation) return;

        animation.cancel();
        item._daRevealAnimation = null;
      })
      .catch(() => {
        /* Expected if results change during animation */
      });
  });
}

function enterSearch(query) {
  if (!searchResults) return;

  const matches = searchProducts(query);

  renderSearchResults(matches);

  searchResults.classList.add('is-active');
  searchResults.setAttribute('aria-hidden', 'false');
}


function exitSearch() {
  if (!searchResults) return;

  searchResults.classList.remove('is-active');
  searchResults.setAttribute('aria-hidden', 'true');

  if (searchList) {
    searchList.innerHTML = '';
  }

  if (searchEmpty) {
    searchEmpty.hidden = true;
  }
}


    /* ============================================
       Panel Content Reveal
       Uses Web Animations API
       ============================================ */

    function getRevealSettings() {
      const styles = getComputedStyle(nav);

      return {
        duration:
          parseInt(
            styles.getPropertyValue('--da-nav-reveal-duration'),
            10
          ) || 220,

        distance:
          parseFloat(
            styles.getPropertyValue('--da-nav-reveal-distance')
          ) || 5,

        stagger: 28
      };
    }


    function cancelRevealAnimation(item) {
      if (!item._daRevealAnimation) return;

      item._daRevealAnimation.cancel();
      item._daRevealAnimation = null;
    }


    function preparePanelReveal(panel) {
      if (!panel) return;

      const items = Array.from(
        panel.querySelectorAll('.DAMicroNav__Reveal')
      );

      if (!items.length) return;

      const { distance } = getRevealSettings();

      items.forEach(item => {
        cancelRevealAnimation(item);

        item.style.opacity = '0';
        item.style.transform = `translateY(${distance}px)`;
      });
    }


    function playPanelReveal(panel) {
      if (!panel) return;

      const items = Array.from(
        panel.querySelectorAll('.DAMicroNav__Reveal')
      );

      if (!items.length) return;

      const {
        duration,
        distance,
        stagger
      } = getRevealSettings();


      items.forEach((item, index) => {
        cancelRevealAnimation(item);

        item.style.opacity = '';
        item.style.transform = '';

        const animation = item.animate(
          [
            {
              opacity: 0,
              transform: `translateY(${distance}px)`
            },
            {
              opacity: 1,
              transform: 'translateY(0)'
            }
          ],
          {
            duration: duration,
            delay: index * stagger,
            easing: 'cubic-bezier(.22, 1, .36, 1)',
            fill: 'both'
          }
        );

        item._daRevealAnimation = animation;

        animation.finished
          .then(() => {
            if (item._daRevealAnimation !== animation) return;

            animation.cancel();
            item._daRevealAnimation = null;

            item.style.opacity = '';
            item.style.transform = '';
          })
          .catch(() => {
            /* Expected when navigating quickly */
          });
      });
    }


    /* ============================================
       Panel Navigation
       ============================================ */

    function setActivePanel(nextPanel, direction) {
      if (!nextPanel || nextPanel === activePanel) return;

      const previousPanel = activePanel;

      const duration = parseInt(
        getComputedStyle(nav)
          .getPropertyValue('--da-nav-panel-duration'),
        10
      ) || 240;


      /*
       * Prepare incoming content while the panel
       * is still outside the visible state.
       */

      preparePanelReveal(nextPanel);


      /*
       * Starting panel positions.
       */

      nextPanel.style.transition = 'none';
      previousPanel.style.transition = 'none';

      nextPanel.classList.add('is-active');
      nextPanel.setAttribute('aria-hidden', 'false');


      if (direction === 'back') {
        nextPanel.style.transform = 'translateX(-18%)';
        nextPanel.style.opacity = '0';

        previousPanel.style.transform = 'translateX(0)';
        previousPanel.style.opacity = '1';
      } else {
        nextPanel.style.transform = 'translateX(100%)';
        nextPanel.style.opacity = '1';

        previousPanel.style.transform = 'translateX(0)';
        previousPanel.style.opacity = '1';
      }


      /*
       * Commit the starting state.
       */

      nextPanel.getBoundingClientRect();


      /*
       * Enable horizontal movement.
       */

      const transition =
        `transform ${duration}ms cubic-bezier(.22, 1, .36, 1), ` +
        `opacity ${Math.min(duration, 180)}ms ease-out`;

      nextPanel.style.transition = transition;
      previousPanel.style.transition = transition;


      /*
       * Start horizontal movement.
       */

      if (direction === 'back') {
        nextPanel.style.transform = 'translateX(0)';
        nextPanel.style.opacity = '1';

        previousPanel.style.transform = 'translateX(100%)';
        previousPanel.style.opacity = '0';
      } else {
        nextPanel.style.transform = 'translateX(0)';

        previousPanel.style.transform = 'translateX(-18%)';
        previousPanel.style.opacity = '0';
      }


      /*
       * Start the content reveal while the new
       * panel is entering.
       */

      window.setTimeout(() => {
        playPanelReveal(nextPanel);
      }, 70);


      /*
       * Finish panel transition.
       */

      window.setTimeout(() => {
        previousPanel.classList.remove('is-active');
        previousPanel.setAttribute('aria-hidden', 'true');

        previousPanel.removeAttribute('style');
        nextPanel.removeAttribute('style');

        activePanel = nextPanel;
      }, duration);
    }


    /* ============================================
       Open / Close
       ============================================ */

    function openNavigator(focusSearch) {
      preparePanelReveal(activePanel);

      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');

      document.documentElement.classList.add('da-micro-nav-open');


      window.setTimeout(() => {
        playPanelReveal(activePanel);
      }, 90);


      if (focusSearch && searchInput) {
        window.setTimeout(() => {
          searchInput.focus();
        }, 180);
      }
    }


    function closeNavigator() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');

      document.documentElement.classList.remove('da-micro-nav-open');


      /*
       * Reset search when the complete navigator closes.
       */

      if (searchInput) {
        searchInput.value = '';
      }

      if (searchClear) {
        searchClear.hidden = true;
      }

      exitSearch();


      /*
       * Cancel any reveal animations still running.
       */

      nav
        .querySelectorAll('.DAMicroNav__Reveal')
        .forEach(item => {
          cancelRevealAnimation(item);

          item.style.opacity = '';
          item.style.transform = '';
        });
    }


    /* ============================================
       External Header Triggers
       ============================================ */

    document.addEventListener('click', function (event) {
      const menuTrigger = event.target.closest('[data-da-nav-open]');
      const searchTrigger = event.target.closest('[data-da-nav-search-open]');
      const closeTrigger = event.target.closest('[data-da-nav-close]');


      if (menuTrigger) {
        event.preventDefault();

        openNavigator(false);

        return;
      }


      if (searchTrigger) {
        event.preventDefault();

        openNavigator(true);

        return;
      }


      if (closeTrigger && nav.contains(closeTrigger)) {
        event.preventDefault();

        closeNavigator();
      }
    });


    /* ============================================
       Panel Buttons
       ============================================ */

    nav.addEventListener('click', function (event) {
      const forward = event.target.closest('[data-da-nav-target]');
      const back = event.target.closest('[data-da-nav-back]');


      if (forward) {
        const targetKey = forward.dataset.daNavTarget;

        const nextPanel = panels.find(
          panel => panel.dataset.daPanel === targetKey
        );


        if (!nextPanel) {
          console.warn(
            `DA Micro Navigator: panel "${targetKey}" was not found.`
          );

          return;
        }


        history.push(activePanel.dataset.daPanel);

        setActivePanel(nextPanel, 'forward');
      }


      if (back) {
        const previousKey = history.pop();

        if (!previousKey) return;

        const previousPanel = panels.find(
          panel => panel.dataset.daPanel === previousKey
        );

        if (!previousPanel) return;

        setActivePanel(previousPanel, 'back');
      }
    });


    /* ============================================
       Search Input
       ============================================ */

    if (searchInput && searchClear) {
      searchInput.addEventListener('input', function () {
        const query = searchInput.value.trim();

        searchClear.hidden = !query;


        if (query) {
          enterSearch(query);
        } else {
          exitSearch();
        }
      });


      searchClear.addEventListener('click', function () {
        searchInput.value = '';
        searchClear.hidden = true;

        searchInput.focus();

        searchInput.dispatchEvent(
          new Event('input', {
            bubbles: true
          })
        );
      });
    }


    /* ============================================
       Keyboard
       ============================================ */

    document.addEventListener('keydown', function (event) {
      if (
        event.key === 'Escape' &&
        nav.classList.contains('is-open')
      ) {
        closeNavigator();
      }
    });
  }


  /* ============================================
     Initialization
     ============================================ */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initDAMicroNav
    );
  } else {
    initDAMicroNav();
  }


  document.addEventListener(
    'shopify:section:load',
    initDAMicroNav
  );
})();